"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.greenPalette = void 0;
var tempusGreen = '#36BCA2';
var greenPalette = {
  // TODO Possibly deprecating this color in v3, talk with Sarah W.
  greenDark: '#1A9F90',
  green: tempusGreen,
  tempusGreen: tempusGreen,
  greenLight: '#9ADDD0',
  greenLightest: '#E0F4F0'
};
exports.greenPalette = greenPalette;